import { Components } from '@mui/material/styles/components';
import theme from '../../provider/controllerBaseTheme';

export const SliderComponent: Components = {
  MuiSlider: {
    styleOverrides: {
      markLabel: {
        color: theme.palette.text.primary,
        opacity: 0.5,
        '&.MuiSlider-markLabelActive': {
          color: theme.palette.text.primary,
          opacity: 1,
        },
      },
    },
  },
};
